// Cada alternativa es una opción excluyente para el mismo renglón.
export const calcularTotalOfertado = (productos = []) => productos.reduce((total, producto) => {
  const cantidad = Number(producto.cantidadVerificada ?? producto.cantidad) || 0;
  const precios = (producto.cotizaciones || []).map((oferta) => Number(oferta.precio)).filter((precio) => Number.isFinite(precio) && precio > 0);
  if (cantidad <= 0 || !precios.length) return total;
  return {
    minimo: total.minimo + cantidad * Math.min(...precios),
    maximo: total.maximo + cantidad * Math.max(...precios),
    tieneAlternativas: total.tieneAlternativas || precios.length > 1,
  };
}, { minimo: 0, maximo: 0, tieneAlternativas: false });
